{
  "archivist": {
    "greet_unknown": {
      "lines": [
        "Another traveller.",
        "Don't mind the dust — we don't get many new faces.",
        "You look new. What do we call you?"
      ],
      "awaits_input": "name",
      "next": "archivist:ledger_prompt"
    },
    "ledger_prompt": {
      "lines": [
        "{name}. Not bad. Suits you, I think.",
        "Shall I write your name in the ledger?"
      ],
      "choices": [
        { "label": "Write it down.", "effect": "signup" },
        { "label": "Not yet — let me look around.", "effect": "dismiss" }
      ]
    },
    "greet_returning": {
      "lines": [
        "{name}. Back again.",
        "Take your time. The hearth doesn't judge."
      ],
      "choices": [
        { "label": "What is this place?", "effect": "next", "next": "archivist:what_is_this" },
        { "label": "Who are the Keepers?", "effect": "next", "next": "archivist:keepers" },
        { "label": "Nothing. Just passing through.", "effect": "dismiss" }
      ]
    },
    "what_is_this": {
      "lines": [
        "The Tavern? It's a place. A real one, if you let it be.",
        "People come here to build worlds — the sort you run games in. Lore, maps, characters, sessions at a table. All the bookkeeping a Dungeon Master does between the good bits.",
        "We handle the bookkeeping so you can get back to the imagination."
      ],
      "choices": [
        { "label": "Who are the Keepers?", "effect": "next", "next": "archivist:keepers" },
        { "label": "Alright. I'll poke around.", "effect": "dismiss" }
      ]
    },
    "keepers": {
      "lines": [
        "Five of us. The Archivist — that's me. The Herald watches your words. The Scribe listens at your sessions. The Cartographer thinks in maps. The Artificer tinkers with rules.",
        "Only I'm in tonight. The others are — how shall I put it — still being poured."
      ],
      "choices": [
        { "label": "What is this place?", "effect": "next", "next": "archivist:what_is_this" },
        { "label": "I'll keep looking around.", "effect": "dismiss" }
      ]
    }
  },
  "hearth": {
    "default": {
      "lines": [
        "The hearth crackles. The warmth pushes back the damp of the road.",
        "Somewhere in the flames you think you see a shape — a face, a story — and then it's just fire again.",
        "You feel steadier."
      ]
    }
  },
  "ledger": {
    "default": {
      "lines": [
        "The ledger is open to the last page. Names in careful hand, one after the other. Some old, some from tonight.",
        "You recognise none of them. You wonder if any of them recognised theirs, the first time they saw the page."
      ]
    },
    "named": {
      "lines": [
        "The ledger is open to the last page. Near the bottom, written in the Archivist's hand — yours.",
        "{name}. Just the name. No title, no flourish. You hadn't earned those yet."
      ]
    }
  },
  "noticeboard": {
    "default": {
      "lines": [
        "A cork board thick with tacked notices:",
        "\"Party seeks a cleric. Patient rogues welcome. No paladins.\"",
        "\"Lost: one handful of persistence. Found it? Return to any DM prepping Session 14.\"",
        "\"Rules lawyers — the Artificer has a word for you. Bring your own dice.\"",
        "You smile despite yourself."
      ]
    }
  },
  "bookshelf": {
    "default": {
      "lines": [
        "Ledgers. Bestiaries. A slim volume titled \"House Rules You'll Regret.\" A thick one just called \"Canon.\"",
        "One book is chained to the shelf. Its spine reads \"Session Zero.\" You leave it where it is.",
        "Stories upon stories. You pull nothing down."
      ]
    }
  },
  "scholar": {
    "default": {
      "lines": [
        "A scholar at the middle table, nose deep in a ledger. They don't look up.",
        "\"Hmm. Sorry. Cross-referencing the NPC notes from Session Twelve. Third time this month.\"",
        "They turn a page.",
        "\"Don't suppose you've seen a merchant named Eren? Or was it Aren? That's rather the problem.\""
      ]
    }
  }
}
